import {VcrEntity} from './entity';
import {User} from '@app/models/vcr-entity/user';
import {CurrentClass} from '@app/models/current-class';

export class AppBaseInfo extends VcrEntity<any> {

  get version(): string {
    return this.data.version;
  }

  get hostname(): string {
    return this.data.hostname;
  }

  get roomNum(): number {
    return this.data.roomNumber;
  }

  get vcrTitle(): string {
    return this.data.vcrTitle;
  }

  get currentClass(): CurrentClass {
    return this.data.currentClass;
  }

  get cmsUrl(): string {
    return this.data.cmsUrl;
  }
  get studentPortalUrl(): string {
    return this.data.studentPortalUrl;
  }
  get newStudentPortalUrl(): string {
    return this.data.newStudentPortalUrl;
  }

  get isCurrentClassParticipant(): boolean {
    return this.data.currentClassParticipant;
  }
  get isFirstConnectToRoom(): boolean {
    return this.data.firstConnectToRoom;
  }

  get isClassClosed(): boolean {
    return this.data.classClosed;
  }

  get isInDNDMode(): boolean {
    return this.data.inDNDMode;
  }

  get gtmContainerId(): string {
    return this.data.gtmContainerId;
  }

  get sessionUser(): User {
    return this.data.sessionUser;
  }

  set sessionUser(user: User) {
    this.data.sessionUser = user;
  }

  get participants(): User[] {
    return this.data.participants;
  }

  set participants(participants: User[]) {
    this.data.participants = participants;
  }
}
